import React, {useState} from "react";
import {Loader} from "@/customComponents/uiComponents/Loader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {BOOKING_CONSTRAINTS} from "@/constants/booking";

const MAX_LENGTH = BOOKING_CONSTRAINTS.SPECIAL_REQUEST_MAX_LENGTH;

// Ported from plugin customComponent/spacialRequestForm.jsx
export function SpacialRequestForm(props) {
    /**
     * Trimmed on the way IN as well as from the keyboard. A draft saved before this cap
     * existed can still be sitting in storage over the limit — restoring it verbatim
     * would put the form straight back into the state the server rejects, on a field the
     * passenger never touched.
     */
    const [textRequest, setTextRequest] = useState(
        () => String(storage.get(STORAGE_KEYS.SPECIAL_REQUEST, "") || "").slice(0, MAX_LENGTH)
    );
    const [caringPet, setCaringPet] = useState(
        storage.get(STORAGE_KEYS.CARING_PET, false)
    );
    const [quietRide, setQuietRide] = useState(
        storage.get(STORAGE_KEYS.QUIET_RIDE, false)
    );
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleTextChange = (e) => {
        // Sliced, not rejected. `maxLength` on the <textarea> stops typing past the cap
        // but does NOT apply to a paste in every browser — and a paste is exactly how an
        // over-long instruction arrives.
        const value = e.target.value.slice(0, MAX_LENGTH);
        setTextRequest(value);
        storage.set(STORAGE_KEYS.SPECIAL_REQUEST, value);
        if (value.trim()) setError("");
    };

    const remaining = MAX_LENGTH - textRequest.length;

    const handleDoneClick = () => {
        if (!textRequest.trim()) {
            setError("Please enter your instruction");
            return;
        }
        setError("");
        setLoading(true);
        storage.set(STORAGE_KEYS.CAR_SPECIAL_REQUEST, true);

        setTimeout(() => {
            if (props.previousStep) {
                props.setStep(props.previousStep);
            } else {
                setLoading(false);
                props.setSpacialRequestPopup(false);
                if (props.setIsCarSpecialRequest) {
                    props.setIsCarSpecialRequest(true);
                }
            }
        }, 800);
    };

    const handleCheckbox = (setter, key) => (e) => {
        setter(e.target.checked);
        storage.set(key, e.target.checked);
    };

    return (
        <>
            <div className="hopn-spacial-request">
                <p>Let driver know more about your requests</p>
                <div className="spaial-request-btn">
                    <div className="request-option">
                        <input
                            type="checkbox"
                            id="caring-pet"
                            checked={caringPet}
                            onChange={handleCheckbox(setCaringPet, STORAGE_KEYS.CARING_PET)}
                        />
                        <label htmlFor="caring-pet">
                            <h6>Caring pet?</h6>
                        </label>
                    </div>

                    <div className="request-option">
                        <input
                            type="checkbox"
                            id="quiet-ride"
                            checked={quietRide}
                            onChange={handleCheckbox(setQuietRide, STORAGE_KEYS.QUIET_RIDE)}
                        />
                        <label htmlFor="quiet-ride">
                            <h6>Quiet Ride</h6>
                        </label>
                    </div>
                </div>

                <h6>Enter any instruction</h6>

                <textarea
                    name="detail-request"
                    onChange={handleTextChange}
                    value={textRequest}
                    maxLength={MAX_LENGTH}
                    hopn-data-index="special_textarea"
                />

                {/* The cap is the backend's and was invisible: the only way to find it was
                    to submit and be told at "We are processing your booking…". Counts DOWN
                    so the shrinking number is itself the warning, red for the last 50. */}
                <p className={`hopn-special-request-count${remaining <= 50 ? ' is-low' : ''}`}>
                    {remaining} characters left
                </p>

                {error && (<p className="hopn-error-text">{error}</p>)}

                <button
                    className="hopn-add-passenger-button"
                    onClick={handleDoneClick}
                    disabled={loading}
                >
                    {loading ? (<Loader color="#fff"/>) : "Done"}
                </button>

                <button
                    className="hopn-add-passenger-button transparent no-icon"
                    onClick={() => {
                        setTextRequest('');
                        setCaringPet(false);
                        setQuietRide(false);
                        setError('');
                        storage.remove(STORAGE_KEYS.SPECIAL_REQUEST);
                        storage.set(STORAGE_KEYS.CARING_PET, false);
                        storage.set(STORAGE_KEYS.QUIET_RIDE, false);
                        storage.set(STORAGE_KEYS.CAR_SPECIAL_REQUEST, false);

                        if (props.previousStep) {
                            props.setStep(props.previousStep);
                        } else {
                            props.setSpacialRequestPopup(false);
                            if (props.setIsCarSpecialRequest) {
                                props.setIsCarSpecialRequest(false);
                            }
                        }
                    }}
                    disabled={loading}
                >
                    Cancel
                </button>
            </div>
        </>
    );
}

export default SpacialRequestForm;
